import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
      {items.map((item, index) => (
        <span key={item.label} className="flex items-center gap-2">
          {index > 0 && <ChevronRight className="size-3.5" />}
          <a href={item.href} className="hover:text-foreground focus:outline-none focus:ring-2 focus:ring-ring">
            {item.label}
          </a>
        </span>
      ))}
    </nav>
  );
}